module.exports = __webpack_public_path__ + "static/media/lock-sign.5224354d.svg";